<script>
	import { onMount } from 'svelte';
	import Plyr from 'plyr';
	import 'plyr/dist/plyr.css';
	import { resource } from '$lib/utils.js';
	export let title;
	export let audioUrl;
	onMount(() => {
		Array.from(document.querySelectorAll('.player-audio')).map(
			(p) => new Plyr(p, { controls: ['play', 'progress', 'current-time', 'duration'] })
		);
	});
	let colors = ['#F8991D', '#F81D79', '#F8441D'];
	let colorIndex = title.length % colors.length;
</script>

<div
	class="w-[290px] sm:w-[310px] bg-[#F6F6F6] h-[93%] font-readex font-light flex flex-col justify-evenly gap-2 pb-[27px] hover:shadow-[2px_2px_17px_#8686864d] my-3 duration-300 ease-in-out border-[#EDEDED] border-solid border-[1px] audio"
>
	<div
		class="h-[240px] sm:h-[247px] w-full relative overflow-hidden flex justify-center items-center"
	>
		<svg
			width="78"
			height="78"
			viewBox="0 0 78 78"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			style="width: 200px;"
		>
			<path
				d="M63.973 18.9194L34.723 8.28537C33.7412 7.92645 32.6873 7.80988 31.6507 7.94555C30.6142 8.08121 29.6258 8.46512 28.7695 9.06463C27.9131 9.66414 27.2141 10.4615 26.732 11.3891C26.2498 12.3166 25.9987 13.3468 26 14.3921V34.3114C24.0333 33.1396 21.7893 32.5146 19.5 32.5011C12.3305 32.5011 6.5 38.3316 6.5 45.5011C6.5 52.6706 12.3305 58.5011 19.5 58.5011C26.6695 58.5011 32.5 52.6706 32.5 45.5011V14.3921L61.75 25.0261V47.3081C59.7824 46.1388 57.5388 45.5151 55.25 45.5011C48.0805 45.5011 42.25 51.3316 42.25 58.5011C42.25 65.6706 48.0805 71.5011 55.25 71.5011C62.4195 71.5011 68.25 65.6706 68.25 58.5011V25.0261C68.25 22.3026 66.5308 19.8456 63.973 18.9194ZM19.5 52.0011C15.9152 52.0011 13 49.0859 13 45.5011C13 41.9164 15.9152 39.0011 19.5 39.0011C23.0848 39.0011 26 41.9164 26 45.5011C26 49.0859 23.0848 52.0011 19.5 52.0011ZM55.25 65.0011C51.6652 65.0011 48.75 62.0859 48.75 58.5011C48.75 54.9164 51.6652 52.0011 55.25 52.0011C58.8348 52.0011 61.75 54.9164 61.75 58.5011C61.75 62.0859 58.8348 65.0011 55.25 65.0011Z"
				fill={colors[colorIndex]}
			/>
		</svg>
	</div>
	<div class="flex flex-col justify-center items-center gap-3 mt-2 px-[10px]">
		<h3 class="text-base self-start">{title}</h3>
		<audio class="player-audio" id="player" controls>
			<source src={resource(audioUrl)} type="audio/mp3" />
		</audio>
	</div>
</div>

<style>
	.audio {
		position: relative;
		--plyr-audio-control-color: #f7c918;
		--plyr-audio-progress-buffered-background: #000;
	}
	:global(.audio .plyr) {
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
	}
	:global(.audio .plyr__controls__item[type='button']) {
		position: absolute;
		bottom: 108px;
		right: 0px;
		width: 50px;
		height: 50px;
	}
	:global(.audio .plyr__controls__item--duration) {
		position: absolute;
		bottom: 108px;
		right: 0px;
		width: 50px;
		height: 50px;
	}
	:global(.plyr__time--current) {
		color: black;
	}
	:global(.plyr__time--duration) {
		color: black;
		position: absolute;
		bottom: 10px;
		right: 10px;
	}
</style>
